import { Node } from "@tiptap/core";
import { SvelteNodeViewRenderer } from "svelte-tiptap";
import DraggableItem from "./DraggableItem.svelte";

export default Node.create({
  name: "draggableItem",

  group: "block list",

  content: "block*",

  draggable: true,

  parseHTML() {
    return [
      {
        tag: 'div[data-type="draggable-item"]',
      },
    ];
  },

  // renderHTML({ HTMLAttributes }) {
  //   return ['div', mergeAttributes(HTMLAttributes, { 'data-type': 'draggable-item', class:"flex flex-1"}),
  //   ["div", {class: styles.dragHandle, contenteditable: "false", draggable: "true", "data-drag-handle": "true"}],
  //   ["div", {"class": "inline-grid grid-cols-2 gap-4 bg-gray-100 rounded-md p-2 border-gray-500 border-2 w-full" }, 0]]
  // },
  addNodeView() {
    return SvelteNodeViewRenderer(DraggableItem);
  },
});
